import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import DriveItemUtils, { ResolutionDisplayType } from '../../../utils/driveItem';
import SelectionToggler from '../../Selection/Toggler';
import { StyledTheaterFooter, Extension, Label, ActionIcons, DownloadButton } from './styles';
import UserAgentUtils from '../../../utils/userAgent';
import StatsUtils from '../../../utils/statistics';
import { DownloadMode } from '../../../containers/DownloadManager/reducer';
import { requestWebDownloadItem, requestMobileAppDownload } from '../../../containers/DownloadManager/actions';
import Utils from '../../../utils';
import DownloadManagerUtils from '../../../utils/downloadManager';

export interface TheaterFooterProps {
	driveItem: Api.DriveItem;
	isDownloadable: boolean;
	isZoomable: boolean;
	isZoomEnabled: boolean;
	onZoomToggle: () => void;
	dispatch: Dispatch<StoreState>;
}

const TheaterFooter = ({
	driveItem,
	isDownloadable,
	isZoomable,
	isZoomEnabled,
	onZoomToggle,
	dispatch,
}: TheaterFooterProps) => {
	const extension = DriveItemUtils.getExtension(driveItem);
	const label = DriveItemUtils.getDisplayName(driveItem);

	const handleDownloadClick = () => {
		const { isMobileApp } = UserAgentUtils;

		StatsUtils.trackDownload([driveItem]);

		if (!isMobileApp) {
			dispatch(requestWebDownloadItem(driveItem));
		} else {
			dispatch(requestMobileAppDownload(driveItem, DownloadMode.Requested));
		}
	};

	return (
		<StyledTheaterFooter className="StyledTheaterFooter">
			<Extension className="TheaterFooterExtension">{extension}</Extension>
			<Label className="TheaterFooterLabel">{label}</Label>
			<ActionIcons className="TheaterFooterActionIcons">
				{isDownloadable &&
					<DownloadButton
						type="button"
						className="TheaterDownloadButton"
						onClick={handleDownloadClick}
					>
						{Utils.getSvgIcon('iconset_uprez_download_bold')}
					</DownloadButton>
				}
				{isZoomable &&
					<DownloadButton
						type="button"
						className="TheaterZoomButton"
						onClick={onZoomToggle}
					>
						{Utils.getSvgIcon(isZoomEnabled ? 'iconset_zoom-down' : 'iconset_zoom-up')}
					</DownloadButton>
				}
				<div className="TheaterSelectionToggler">
					<SelectionToggler
						itemId={driveItem.id}
						displayMode={ResolutionDisplayType.Theater}
					/>
				</div>
			</ActionIcons>
		</StyledTheaterFooter>
	);
};

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		galleryInfos: { template: { sharedMethods } },
		downloadManager,
	} = state;
	const isOnline = UserAgentUtils.isOnline();
	const isImage = ownProps.driveItem.type === Api.DriveItemType.Image;
	const isDownloaded = DownloadManagerUtils.isItemDownloaded(downloadManager, ownProps.driveItem.id);

	return {
		downloadManager,
		sharedMethods,
		isDownloadable: DriveItemUtils.isDownloadable(ownProps.driveItem, downloadManager, sharedMethods),
		isZoomable: isImage && (isOnline || isDownloaded),
	};
};

export default connect(mapStateToProps)(TheaterFooter);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Footer/index.tsx